import type { ErrorEvent } from '@sentry/vue';

import { MF_DSN_KEY } from '@/shared/sentry/transports';

export default function filterMFError(event: ErrorEvent): ErrorEvent {
  if (event?.exception?.values?.[0].stacktrace?.frames) {
    const { frames } = event.exception.values[0].stacktrace;
    const metadata = frames
      .filter((frame) => frame.module_metadata?.dsn)
      .map((v) => v.module_metadata)
      .slice(-1);

    if (metadata.length) {
      event.extra = {
        ...event.extra,
        [MF_DSN_KEY]: metadata,
      };
    }
  }

  return event;
}
